import { Dispatch, SetStateAction, useState } from 'react';

import {
  MaterialTypeDefinition,
  materialTypeDefinitions,
  MaterialTypeName,
  MaterialTypeOption,
  materialTypeOrder,
  SearchAssetResult,
} from '../../entity/SearchAsset';

export type SubType = {
  name: string;
  index: number;
  isService: boolean;
  isTempo: boolean;
};

const getSubTypes = (materialType: MaterialTypeDefinition): ReadonlyArray<SubType> => {
  const subTypeNames = (materialType.tempo == null
    ? materialType.searchService
    : materialType.tempo) as ReadonlyArray<string>;

  return subTypeNames.map((name, i) => ({
    name,
    index: i,
    isService: materialType.name !== 'audio',
    isTempo: materialType.name === 'audio',
  }));
};

export const useTypeAndSubType = ({
  defaultType,
  setSelectedSearchAsset,
}: {
  defaultType: MaterialTypeName;
  materialTypeOption: MaterialTypeOption;
  setSelectedSearchAsset: Dispatch<SetStateAction<SearchAssetResult[number] | null>>;
}) => {
  const [materialType, setMaterialType] = useState<MaterialTypeDefinition>(materialTypeDefinitions[defaultType]);
  const [subTypes, setSubTypes] = useState(getSubTypes(materialType));
  const [subType, setSubType] = useState(subTypes[0]);

  const handleMaterialTypeChange = (newMaterialTypeIndex: number) => {
    const nextMaterialType = materialTypeDefinitions[materialTypeOrder[newMaterialTypeIndex]];
    const nextSubTypes = getSubTypes(nextMaterialType);
    setSelectedSearchAsset(null);

    setMaterialType(nextMaterialType);
    setSubTypes(nextSubTypes);
    setSubType(nextSubTypes[0]);
  };
  const handleSubTypeChange = (newSubTypeIndex: number) => {
    setSelectedSearchAsset(null);
    setSubType(subTypes[newSubTypeIndex]);
  };

  return [
    { materialType, subType, subTypes },
    { handleMaterialTypeChange, handleSubTypeChange },
  ] as const;
};
